import { Link } from "@StarberryUtils";
import React, { useEffect, useState } from "react"
import gql from "graphql-tag"
import { useQuery } from '@apollo/client';
import { useStaticQuery, graphql } from "gatsby";
import { Container, Row } from 'react-bootstrap';
import ReactReadMoreReadLess from "react-read-more-read-less"
import moment from 'moment';
import HTMLReactParser from 'html-react-parser';
import axios from 'axios';
import { Rating } from 'react-simple-star-rating'
import { Helmet } from "react-helmet";
import Logo from '../../../images/dacha-logo-blue.png';
import $ from "jquery";
import Sidebar from "../../Sidebar/Sidebar";
import OtherNews from "./OtherNews";
import ShareNews from "./Share";
import StaticContact from "../ContactUs/StaticContact";
import NewsStaticContact from "../ContactUs/NewsStaticContact";
import NewsLetter from "../NewsLetter/NewsLetter";
import PlayVideo from "../../Play/custom-video";
import SEO from "../../seo"
import StarSVG from "../../../images/star.svg"
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";
import NotFoundPage from "../../404Page/404Page";
import useDeviceMedia from "../../utils/useDeviceMedia";
const GET_NEWS = gql`
  query GetNews($url: String!){	
    newsItems(sort:"Date:desc", where:{URL:$url})  {
        id
        Content
        Title
        Date
		published_at
        updatedAt
        Embed_Video_URL
        Featured
        Meta_Description
        Meta_Title
        Tile_Image {
          alternativeText
          url
        }
		Banner_Image{
			alternativeText
			url
		  }
		Author {
			id
			Name
			About
			Designation
			Tile_Image {
			  alternativeText
			  url
			}
			URL
		}
		Reviewed_By {
			id
			Name  
			URL
		}
        news_category {
          Name
          URL
        }
		Viewers
		Ratings
		News_Content_Block {
			Title
			Content
			Video_Url
			Show_Newsletter_Form
			Image {
			  alternativeText
			  url
			}
			id
		}
        imagetransforms
      }
  }
`;

const NewsDetail = (props) => {
	const [render, setRender] = useState(false)
	const [ip, setIP] = useState(null)
	const [rating, setRating] = useState(0)
	const [pointerEnter, setPointerEnter] = useState(false)
	const [totalReviews, setTotalReviews] = useState(0)
	const [avgRating, setAvgRating] = useState(0)
	const [ratingReadOnly, setRatingReadonly] = useState(false);
	const { isMobile } = useDeviceMedia({ max: "991.98px" });
	const { isOnlyMobile } = useDeviceMedia({ max: "767px" });
	const { loading, error, data } = useQuery(GET_NEWS, { variables: { url: props.detailpage } });

	let news = data?.newsItems[0];
	const updateNews = async (updateData) => {
		let url = process.env.GATSBY_STRAPI_SRC + "/news-items/" + news?.id;
		let reqHeaders = {
			headers: {
				Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
			}
		}
		axios.put(url, updateData, reqHeaders)
			.then(function (response) {
				//  console.log('update', response) 
			})
			.catch(function (error) {
				console.log(error);
			})
	}
	//function to load ip address from the API
	const getIPData = async (ratings) => {
		const res = await axios.get('https://geolocation-db.com/json/')
		const ratingMatch = ratings?.find(r => r['ip-address'] === res.data.IPv4);
		if (ratingMatch) {
			setRatingReadonly(true)
			setRating(ratingMatch.rating)
		} else {
			setRating(getAvgRating(ratings))
		}
		setIP(res.data.IPv4)
	}

	//rating count

	const getAvgRating = (ratings) => {
		let totalStars = 0;
		let totalRating = ratings?.length;
		ratings?.map(a => {
			totalStars += (a.rating)
		});
		return (Math.round(totalStars / totalRating * 10) / 10)
	}

	useEffect(() => {
		// New home click to scroll 
		if (!loading) {
			// setRender(true)
			$(document).on("click", ".less-content", function () {
				$('html, body').animate({
					scrollTop: $("#author").offset().top - 150
				}, 1000);
			});
			updateNews({ Viewers: (parseInt(news.Viewers) + 1) });

			if (news.Ratings) {
				setTotalReviews(news.Ratings.length);
				setAvgRating(getAvgRating(news.Ratings))
			}
			getIPData(news.Ratings);
		}
	}, [loading])

	const image_url = news?.Banner_Image?.url
	const meta_Image =  news?.Tile_Image?.url


	let processedImages = JSON.stringify({});
	if (news?.imagetransforms?.Banner_Image_Transforms) {
		processedImages = news.imagetransforms.Banner_Image_Transforms;
	}
	let processedImagesDetail = JSON.stringify({});
	if (news?.imagetransforms?.Detail_Image_Transforms) {
		processedImagesDetail = news.imagetransforms.Detail_Image_Transforms;
	}
	let processedImages2 = JSON.stringify({});
	if (news?.imagetransforms?.Tile_Image_Transforms) {
		processedImages2 = news.imagetransforms.Tile_Image_Transforms;
	}
	let language = typeof window !== 'undefined' ? localStorage.getItem('language') : null
	const pathname = typeof window !== 'undefined' ? window.location.href : ""

	/** string remove all special characters*/
	const removeSpecialChar = (val, symbol = '-') => {
		if (val !== undefined && val !== '' && val !== null && typeof val !== 'number') {
			return val.replace(/[^\w\s]/gi, ' ').replace(/\s\s+/g, ' ').replace(/ /gi, symbol).toLowerCase()
		}
		return val;
	}

	const goToTarget = (target) => {
		$('html, body').animate({
			scrollTop: $(`#${removeSpecialChar(target)}`).offset().top - 100
		}, 1000);
	}
	const handleRating = (rate) => {
		let ratingData = [];
		setRating(rate)
		setRatingReadonly(true)
		if (news.Ratings) {
			ratingData = JSON.parse(JSON.stringify(news.Ratings));
			ratingData.push({ "ip-address": ip, "rating": rate })
		} else {
			ratingData.push({ "ip-address": ip, "rating": rate })
		}
		updateNews({ Ratings: ratingData })
		setTotalReviews(ratingData.length);
		setAvgRating(getAvgRating(ratingData))
	}
	const onPointerEnter = () => {
		setPointerEnter(true)
	}
	const onPointerLeave = () => {
		setPointerEnter(false)
	}

	if (loading) return <div className="gql-loading-screen"><img loading="lazy" src={Logo} alt="Loading - Dacha" /><p>Loading ...</p></div>;

	return (
		<>
			<Helmet>
				<script async src="//www.instagram.com/embed.js"></script>
				<script data-react-helmet="true" type="application/ld+json">{`
						{
						"@context": "http://schema.org",
						"@type": "Article",
						"mainEntityOfPage": {
							"@type": "WebPage",
							"@id": "${pathname}"
						},
						"headline": "${news?.Title}",
						"image": {
							"@type": "ImageObject",
							"url": "${news?.Banner_Image?.url}"
						},
						"datePublished": "${news?.published_at}",
						"dateModified": "${news?.updatedAt}",
						"author": {
							"@type": "Person",
							"name": "${news?.Author?.Name || 'Alessia Sheglova'}",
							"url": "${process.env.GATSBY_SITE_URL}/about-dacha/our-team/${news?.Author?.URL || 'alessia-sheglova'}/",
							"sameAs": "https://www.linkedin.com/in/alessia-sheglova-35061759/",
							"knowsAbout":["Dubai real estate market","Dubai property management","Dubai real estate","Dubai mortgages","Dubai off plan projects","properties for rent in Dubai","properties for sale in Dubai"],
							"jobTitle": "${news?.Author?.Designation || 'CEO'}",
							"image": {
							"@type": "ImageObject",
							"@id": "${process.env.GATSBY_SITE_URL}/about-dacha/our-team/${news?.Author?.URL || 'alessia-sheglova'}/#author-image",
							"url": "${news?.Author?.Tile_Image?.url || 'https://ggfx-dachare.s3.eu-west-2.amazonaws.com/i.dev/Alessia_LP_f8829716e8.jpg'}",
							"caption": "${news?.Author?.Name || 'Alessia Sheglova'}"
							},
							"worksFor": {
							"@type": "OrganizationRole",
							"@id": "${process.env.GATSBY_SITE_URL}/about-dacha/our-team/${news?.Author?.URL || 'alessia-sheglova'}/#organization",
							"name": "Dacha",
							"url": "https://www.dacha.ae/"
							}
						},
						"publisher": {
							"@type": "Organization",
							"name": "Dacha Real Estate",
							"logo": {
							"@type": "ImageObject",
							"url": "https://www.dacha.ae/images/logo-blue.svg"
							}
						},
						"description": "${news?.Meta_Description}"
						}
					`}</script>
			</Helmet>
			<SEO image_url={meta_Image} title={news?.Meta_Title} description={`Check here about ${news?.Meta_Title}, subscribe to us and stay updated for all latest property news.`} location={props.location} />

			<div className={language === 'Russian' ? "russian-page-modules page-modules" : "page-modules news-details-template"}>
				<div className="static-news-detail-top-banner">
					{/* <div className="image">
						{news?.Banner_Image &&
							<ImageTransform imagesources={image_url} renderer="srcSet" imagename="news-items.Banner_Image.full_details" attr={{ alt: `${news.Title} - Dacha`, class: '' }} imagetransformresult={processedImages} id={news.id} />
						} */}
					<Container >
						<Row>
							<div className="content property-news-content col-lg-8 samplee">
								<h1>{news?.Title}</h1>
								<div className="news-info">
									{news?.Author &&
										<>
											<div className="author">
												{/* <ImageTransform 
												imagesources={news.Author.Tile_Image.url} 
												renderer="srcSet" 
												imagename="news-items.Tile_Image.tile_2" 
												attr={{ alt: `${news.Title} - Dacha`, class: '' }} 
												imagetransformresult={processedImages2} 
												id={news.id} /> */}
												<ImageModule 
                                                ImageSrc={news?.Author?.Tile_Image} 
                                                attr={{ alt: news.Title + ' - Dacha', class: '' }} 
                                                ggfx_results={news?.ggfx_results} 
                                                imagename="news-items.Tile_Image.tile_2" 
                                                strapi_id={news?.id} 
                                            	/>  

												
												<Link to={`/about-dacha/our-team/${news.Author?.URL}`} className="author-name">{news.Author.Name}</Link>
											</div>
											<div className="divider">|</div>
										</>
									}
  									{news.Date &&
									<div className="time-infos">
										<i className="icon-clock-grey">
										</i>
										{moment(news?.Date).format("DD/MM/YYYY")}
									</div>
									}
									<div className="divider">|</div>
									<div className="time-infos">
										<i className="icon-eye-grey">
										</i>
										{news?.Viewers} Viewed
									</div>
									<div className="divider">|</div>
									<div className="share-info">
										<ShareNews />
									</div>
									{news?.Reviewed_By &&
										<>
											<div className="divider">|</div>
											<div className="reviewed-by">
												Reviewed By&nbsp;
												<Link to={`/about-dacha/our-team/${news.Reviewed_By?.URL}`}>
													{news.Reviewed_By?.Name}
												</Link>
											</div>
										</>
									}
									
								</div>
								<div>
								
								</div>	
							</div>
						</Row>
					</Container>
					{/* </div> */}
				</div>
				<Container className={`static-content-landing  ${news?.Banner_Image === null ? 'no-banner' : ''}`}>
					<Row>
						<div className="col-xl-8 col-md-12 plain-content news-content">
						{news?.Banner_Image && (
										<div className="news-banner-image">
											{/* <ImageTransform
												imagesources={image_url}
												renderer="srcSet"
												imagename="news-items.Banner_Image.full_details"
												attr={{ alt: `${news.Title} - Dacha`, class: '' }}
												imagetransformresult={processedImages}
												id={news.id}
											/> */}
											<ImageModule 
                                                ImageSrc={news?.Banner_Image} 
                                                attr={{ alt: news.Title + ' - Dacha', class: '' }} 
                                                ggfx_results={news?.ggfx_results} 
                                                imagename="news-items.Banner_Image.full_details"
                                                strapi_id={news?.id} 
                                            	/>
										</div>
									)}
							{news?.News_Content_Block && news?.News_Content_Block?.length > 0 &&
								<div className="table-content">
									<h3>Table of contents</h3>
									<ul>
										{news?.News_Content_Block.map((content, key) => {
											return (
												<li key={key}><a href="javascript:void(0)" onClick={() => { goToTarget(content.Title) }}>{content.Title}</a></li>
											)
										})}

									</ul>

								</div>
							}
							{news?.Content &&
								 <>
								 {HTMLReactParser(news?.Content.replace(/\n/g,'' ), {
								   replace: (domNode) => {
									 if (domNode.name === 'img') {
									   return (
										 <img
										   {...domNode.attribs}
										   //style={{ borderRadius: '8px' }}
										 />
									   );
									 }
								   }
								 })}
							   </>
							}
							<div class="horizontal-line"></div>		
							{news?.News_Content_Block && news?.News_Content_Block?.length > 0 &&
								<div className="content-block">
									{news?.News_Content_Block.map((content, key) => {

										return (
											<div className="block" key={key} id={removeSpecialChar(content.Title)}>
												{content.Image &&
													<div className="image-block">
														{/* <ImageTransform 
														imagesources={content.Image.url} 
														renderer="srcSet" 
														imagename="news-items.Detail_Image.details" 
														attr={{ alt: `${news.Title} - Dacha`, 
														class: '' }} 
														imagetransformresult={processedImagesDetail} 
														id={news.id} /> */}
														<ImageModule 
															ImageSrc={content?.Image} 
															attr={{ alt: news.Title + ' - Dacha', class: '' }} 
															ggfx_results={news?.ggfx_results} 
															imagename="news-items.Detail_Image.details" 
															strapi_id={news?.id} 
															/>
														{content.Video_Url &&
															<div className="banner-btn">
																<PlayVideo url={content.Video_Url}
																/>
															</div>
														}
													</div>
												}

												<h5>{content.Title}</h5>
												{content?.Content &&
													<>
														{HTMLReactParser(content?.Content)}
													</>
												}
												{content?.Show_Newsletter_Form &&
													<NewsLetter innerPage={true} />
												}

											</div>
										)
									})}

								</div>
							}
							<div className="ratings">
								<h5>Rate the article:</h5>
								<div className="stars">
									<Rating
										initialValue={rating}
										onClick={handleRating}
										readonly={ratingReadOnly}
										size={isMobile ? 16 : 24}
										transition
										allowFraction={true}
										fillColor={`#F68F16`}
										onPointerLeave={onPointerLeave}
										onPointerEnter={onPointerEnter}
									/>
									<p>{avgRating} out of {totalReviews}</p>
								</div>
							</div>
							{news.Author && !isOnlyMobile &&
								<div className="author-bottom development" id="author">
									{/* <ImageTransform 
									imagesources={news.Author.Tile_Image.url} 
									renderer="srcSet" 
									imagename="news-items.Tile_Image.tile_2" 
									attr={{ alt: news.Author.Name + ' - Dacha', class: '' }} 
									imagetransformresult={processedImages2} 
									id={news.Author.id} /> */}
									<ImageModule 
                                                ImageSrc={news?.Author?.Tile_Image} 
                                                attr={{ alt: news.Author.Name + ' - Dacha', class: '' }} 
                                                ggfx_results={news?.ggfx_results} 
                                                imagename="news-items.Tile_Image.tile_2" 
                                                strapi_id={news?.Author?.id} 
                                            	/>	
									<div className="author-details">
										<div className="author-details-info">
											<h4>{news.Author.Name}</h4>
											<h6>{news.Author.Designation}</h6>
										</div>
										
										{news.Author?.About && (
											<p>
												<ReactReadMoreReadLess
													charLimit={80}
													readMoreText={"More"}
													readLessText={"Less"}
													readMoreClassName="read-more-less--more more-content"
													readLessClassName="read-more-less--less more-content less-content"
												>
													{(news.Author?.About.replace(/<[^>]+>/g, ''))}
												</ReactReadMoreReadLess>
											</p>
										)}
										<Link to={`/about-dacha/our-team/${news.Author?.URL}`} className="btn btn-new">Read Full Bio</Link>
									</div>
								</div>
								
							}
							{news.Author && isOnlyMobile &&(
								<div className="author-bottom development" id="author">
									<div className="author-info-row">
										{/* <ImageTransform 
											imagesources={news.Author.Tile_Image.url} 
											renderer="srcSet" 
											imagename="news-items.Tile_Image.tile_2" 
											attr={{ alt: news.Author.Name + ' - Dacha', class: '' }} 
											imagetransformresult={processedImages2} 
											id={news.Author.id} 
										/> */}
										<ImageModule 
                                                ImageSrc={news?.Author?.Tile_Image} 
                                                attr={{ alt: news.Author.Name + ' - Dacha', class: '' }} 
                                                ggfx_results={news?.ggfx_results} 
                                                imagename="news-items.Tile_Image.tile_2"  
                                                strapi_id={news?.Author?.id} 
                                            	/>
										<div className="author-details-info-mobile">
											<h4>{news.Author.Name}</h4>
											<h6>{news.Author.Designation}</h6>
										</div>
									</div>
									
									<div className="author-details">
										{news.Author?.About && (
											<p>
												<ReactReadMoreReadLess
													charLimit={80}
													readMoreText={"More"}
													readLessText={"Less"}
													readMoreClassName="read-more-less--more more-content"
													readLessClassName="read-more-less--less more-content less-content"
												>
													{news.Author?.About.replace(/<[^>]+>/g, '')}
												</ReactReadMoreReadLess>
											</p>
										)}
										<Link to={`/about-dacha/our-team/${news.Author?.URL}`} className="btn btn-new">Read Full Bio</Link>
									</div>
								</div>
							)}

						</div>
						<div className="col-xl-4 col-md-12 side-news">
							<Sidebar site={props?.site} timings={props?.site?.Available_Timings} class={"news-sidebar"} />
						</div>
					</Row>
				</Container>
				<OtherNews newsId={news?.id} />
				<NewsStaticContact />
			</div>

		</>
	)
}

export default NewsDetail